document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll("a[href]");

    links.forEach(link => {
        try {
            const linkUrl = new URL(link.href, window.location.origin);
            const currentHost = window.location.hostname;

            // Skip anchor-only links (#section)
            if (link.getAttribute("href").startsWith("#")) return;

            // Check if external
            if (linkUrl.hostname !== currentHost) {
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener noreferrer");
                link.classList.add("forcetab");
            } else {
                link.removeAttribute("target");
            }
        } catch (e) {
            console.warn("Invalid URL:", link.href);
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

    const map = {};

    const normal = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const bold = "𝐀𝐁𝐂𝐃𝐄𝐅𝐆𝐇𝐈𝐉𝐊𝐋𝐌𝐍𝐎𝐏𝐐𝐑𝐒𝐓𝐔𝐕𝐖𝐗𝐘𝐙𝐚𝐛𝐜𝐝𝐞𝐟𝐠𝐡𝐢𝐣𝐤𝐥𝐦𝐧𝐨𝐩𝐪𝐫𝐬𝐭𝐮𝐯𝐰𝐱𝐲𝐳";

    [...bold].forEach((c, i) => map[c] = normal[i]);

    function cleanNode(node) {
        node.childNodes.forEach(child => {

            if (child.nodeType === Node.TEXT_NODE) {

                child.textContent = [...child.textContent]
                    .map(ch => map[ch] || ch)
                    .join('');

            } else {

                cleanNode(child);

            }

        });
    }

    document.querySelectorAll('.article-title, .article-content').forEach(cleanNode);

});